// Status and persistence state setter actions for multiWealthica2Store
// Extracted to keep multiWealthica2Store.ts lean without changing behavior

// Local minimal store typing to avoid circular imports and any
interface ConnectionStateLocal {
  isProcessing: boolean;
  processingState: string;
  isPersisting: boolean;
  persistenceError: string | null;
}

interface StoreStateLocal {
  connections: Map<string, ConnectionStateLocal>;
}

type SetFn = (partial: Partial<StoreStateLocal> | ((state: StoreStateLocal) => Partial<StoreStateLocal>)) => void;
 
type GetFn = () => StoreStateLocal;

export const createStatusStateActions = (set: unknown, _get: unknown) => {
  const _set = set as SetFn;
  return ({
    // === PROCESSING STATE ===
    setProcessingForInstitution: (institutionId: string, processing: boolean) => {
      _set((state) => {
        const connection = state.connections.get(institutionId);
        if (!connection) return state;

        const newConnections = new Map(state.connections);
        newConnections.set(institutionId, {
          ...connection,
          isProcessing: processing
        });

        return { connections: newConnections };
      });
    },

    setProcessingStateForInstitution: (
      institutionId: string,
      processingState: 'processing' | 'complete' | 'failed'
    ) => {
      _set((state) => {
        const connection = state.connections.get(institutionId);
        if (!connection) return state;

        const newConnections = new Map(state.connections);
        newConnections.set(institutionId, {
          ...connection,
          processingState
        });

        return { connections: newConnections };
      });
    },

    // === PERSISTENCE STATE ===
    setPersistingForInstitution: (institutionId: string, persisting: boolean) => {
      _set((state) => {
        const connection = state.connections.get(institutionId);
        if (!connection) return state;

        const newConnections = new Map(state.connections);
        newConnections.set(institutionId, {
          ...connection,
          isPersisting: persisting
        });

        return { connections: newConnections };
      });
    },

    setPersistenceErrorForInstitution: (institutionId: string, error: string | null) => {
      _set((state) => {
        const connection = state.connections.get(institutionId);
        if (!connection) return state;

        const newConnections = new Map(state.connections);
        newConnections.set(institutionId, {
          ...connection,
          persistenceError: error
        });

        return { connections: newConnections };
      });
    },
  });
};
